import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import { VALORANT_MATCH_DETAILS } from "../constants/urls";
import GlipHeader from "../components/mobile/GlipHeader";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import map from '../assets/map_image.svg';
import valo from '../assets/valo_image.png';
import ScorecardList from "../components/mobile/ScordcardList";

// install Swiper modules

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: block;
    /* height: 100vh; */
    flex-direction: column;
    overflow-x: hidden;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
`;

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
`;

const VideoDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 16px;
`;

const VideoDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  max-width: 60%;
`;

const CTASection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  z-index: 1;
`;

const UserName = styled.div`
  font-size: 20px;
  font-weight: 600;
  font-family: "Poppins";
  padding-bottom: 8px;
  z-index: 1;
`;

const Caption = styled.div`
  font-weight: 500;
  font-size: 16px;
  font-family: "Inter";
`;

const BlueBanner = styled.a`
  background: linear-gradient(254.06deg, #59c5e8 -33.43%, #5a8ef1 113.89%);
  font-family: "Inter";
  padding: 10px 16px;
  margin: 16px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

const VideoHolder = styled.video`
  transform: scale(2.5);
  display: flex;
  height: 50vh;
`;

const Container = styled.div`
  padding: 12px 120px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  height: 100vh;
`;

const ProfileBox = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: row;
  background: rgba(21, 21, 29, 1);
  border-radius: 16px;
  margin-bottom: 18px;
  flex-direction: column;
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(21, 21, 29, 1)",
    borderWidth: 0,
    padding: "62px 62px",
    height: "214px",
    width: "340px",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
    alignItems: "center",
  },
};

const MapImage = styled.img`
    width: 100%;
`;

const Red = styled.span`
    color: rgba(255, 96, 96, 1);
    text-transform: uppercase;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    margin-left: 6px;
`;

const Green = styled.span`
    /* color: rgba(75, 179, 75, 1); */
    background: linear-gradient(243.66deg, #CAEA92 -89.52%, #62C0C2 160.8%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-transform: uppercase;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    margin-left: 6px;
`;

const Score = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
`;

const Date = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: rgba(122, 127, 158, 1);
`;

const Banner = styled.div`
    margin-top: 12px;
    background: #141624;
    /* Light / Image Border */

    border: 0.33px solid rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    background: rgba(20, 22, 36, 1);
    padding: 12px 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

`;

const BannerHeading = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;    
`;

const RedCard = styled.div`
    background: linear-gradient(179.2deg, rgba(252, 70, 83, 0.2) 0.68%, rgba(252, 70, 83, 0) 99.32%);
    padding: 16px;
    display: flex;
    flex-direction: row;
    min-height: 114px;
    border-top: 1px solid #FC4653;
    justify-content: space-between;
`;

const Card = styled.div`
    background: linear-gradient(180deg, rgba(20, 22, 36, 0.5) 0%, rgba(20, 22, 36, 0) 100%);
    padding: 16px;
    display: flex;
    flex-direction: row;
    min-height: 114px;
    border-top: 1px solid #1C1F33;
    justify-content: space-between;
`;

const CardHeading = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 125%;   
`;

const CardSubheading = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.2px;
    color: #7A7F9E;  
`;

const CardDetailsWrapper = styled.div`
    display: flex;
    flex-direction : column;    
`;


const CardUsername = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.2px;
    color: #FC4653;   
    margin-top: 20px;
`;

const CardImage = styled.img``;

const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const Tab = styled.div`
  display: flex;
  flex-direction: row;
  padding: 14px;
  text-align: center;
  width: 100%;
  justify-content: center;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
`;

function compare( a, b ) {
  if ( a.score < b.score ){
    return 1;
  }
  if ( a.score > b.score ){
    return -1;
  }
  return 0;
}


export default function Scorecard(props) {

  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('blue');
  const [blueScore, setBlueScore] = useState([]);
  const [redScore, setRedScore] = useState([]);
  const [idMap, setIdMap] = useState({});
  const [deathmatch, setDeathmatch] = useState(false);
  const [data, dataSet] = useState();
  const [blueWon, setBlueWon] = useState(false);
  const { matchId } = useParams();

  useEffect(() => {
    async function fetchMyAPI() {
      let response = await fetch(VALORANT_MATCH_DETAILS + matchId);
      response = await response.json();
      console.log(response);
      if(response.data.matchType == 'deathmatch') setDeathmatch(true);
      const players = response.data.players.sort(compare);
      const blueScore = [];
      const redScore = [];
      const setPlayers = players.map((player, index) => {
        if(player.team === 'Blue') {
          blueScore.push(player);
        } else {
          redScore.push(player);
        }
      });
      await Promise.all(setPlayers);
      setRedScore(redScore);
      setBlueScore(blueScore);

      setBlueWon(response.data.teamScores[1].won);
      setIdMap(response.data.idMap);

      dataSet(response.data);
    }

    fetchMyAPI();
  }, []);

  if(!data) {
    return <></>
  }

  const TabWrapper = (props) => {
    const active = props.active;
    return (
      <Tab style={{
        color: active? '#fff': '#7A7F9E',
        borderBottom: active? '1px solid #4A7DFF': '1px solid transparent'
      }}
      onClick={() => props.onClick()}
      >{props.children}</Tab>
    );
  }
  

  const blue_score = blueScore.map((item, index) => {
    return (
      <ScorecardList
        key={`blue-team-${index}`}
        username={item.name} 
        name={idMap[item.id] ? idMap[item.id].u: ''} 
        kill={item.kills} 
        death={item.deaths} 
        assist={item.assists}
        ultimates={item.ultimates}
        abilities={item.abilities}
        score={item.score}
        damage={item.damageGiven}
        deathmatch={deathmatch}
        index={index}
      />
    );
  })

  const red_score = redScore.map((item, index) => {
    return (
      <ScorecardList
        key={`red-team-${index}`}
        username={item.name} 
        name={idMap[item.id] ? idMap[item.id].u: ''} 
        kill={item.kills} 
        death={item.deaths} 
        assist={item.assists}
        ultimates={item.ultimates}
        abilities={item.abilities}
        score={item.score}
        damage={item.damageGiven}
        deathmatch={deathmatch}
        index={index}
      />
    );
  })

  return (
    <>
      <Mobile>
        <GlipHeader backPress={() => history.goBack()} title={'Scorecard'}/>
        {!deathmatch && <Tabs>
          <TabWrapper onClick={() => setActiveTab('blue')} active={activeTab == 'blue'? true: false}>
            Team Blue
            {blueWon ?
              <Green>WIN</Green>
            :
              <Red>LOSS</Red>
            }
          </TabWrapper>
          <TabWrapper onClick={() => setActiveTab('red')} active={activeTab == 'red'? true: false}>
            Team Red
            {blueWon ?
              <Red>LOSS</Red>
            :
              <Green>WIN</Green>
            }
          </TabWrapper>
        </Tabs>}
        {!deathmatch && activeTab == 'blue'
        ?
        <div>
          {blue_score}
        </div>
        :
        <div>
          {red_score}
        </div>      
        }
      </Mobile>
    </>
  );
}

// module.exports = VideoPage;
